import { render, staticRenderFns } from "./DetailForm.vue?vue&type=template&id=90f4d146&scoped=true"
import script from "./DetailForm.vue?vue&type=script&lang=js"
export * from "./DetailForm.vue?vue&type=script&lang=js"
import style0 from "./DetailForm.vue?vue&type=style&index=0&id=90f4d146&prod&scoped=true&lang=css"
import style1 from "./DetailForm.vue?vue&type=style&index=1&id=90f4d146&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f4d146",
  null
  
)

export default component.exports